export const ACTIVATION_STATUS = {
  SUCCESS: "success",
  FAILED: "failed",
};

export const activationStatusLabels = () => {
  return {
    [ACTIVATION_STATUS.SUCCESS]: "Success",
    [ACTIVATION_STATUS.FAILED]: "Failed",
  };
};
